<div class="layout-with-sidebar">
  <div
    class="layout-with-sidebar__table"
    [ngClass]="{
      'has-details': hasSideBar(),
      'without-vertical-padding': withoutVerticalPadding(),
    }"
    [ngStyle]="hasSideBar() ? mapStyle : {}"
  >
    <!-- LEFT: show content or toggle -->
    @if (hasLeftMenu()) {
      @if (shouldShowLeftSide()) {
        <ng-template [ngTemplateOutlet]="leftSide()"></ng-template>
      } @else {
        <!-- render parent's left-toggle template when collapsed -->
        <div class="layout-with-sidebar__left-toggle">
          <ng-template [ngTemplateOutlet]="leftToggle()"></ng-template>
        </div>
      }
    }

    <!-- MAIN ROW: table + (optional) right column -->
    <div class="layout-with-sidebar__row">
      <div
        class="layout-with-sidebar__table-container"
        [ngStyle]="
          shouldShowRightSide() ? { width: 'calc(100% - ' + rightMenuWidthPx() + 'px)' } : {}
        "
      >
        <ng-template [ngTemplateOutlet]="table()"></ng-template>
      </div>

      <!-- RIGHT: show column or toggle (only if details sidebar is NOT open) -->
      @if (hasRightMenu()) {
        @if (shouldShowRightSide()) {
          <div class="layout-with-sidebar__right-menu" [style.width.px]="rightMenuWidthPx()">
            <ng-template [ngTemplateOutlet]="rightSide()"></ng-template>
          </div>
        } @else {
          @if (shouldShowRightToggle()) {
            <div class="layout-with-sidebar__right-toggle">
              <ng-template [ngTemplateOutlet]="rightToggle()"></ng-template>
            </div>
          }
        }
      }
    </div>
  </div>

  @if (hasSideBar()) {
    <div
      class="layout-with-sidebar__sidebar"
      [ngClass]="{
        'pr-0': isDashboardPage() === true,
        'without-vertical-padding': withoutVerticalPadding(),
      }"
      [ngStyle]="style"
    >
      @if (!hasMultipleSideBar() || !useFixedWidthForMultipleSideBar() || isMultiResizable()) {
        <div
          class="layout-with-sidebar__resize-container"
          mwlResizable
          [validateResize]="validate"
          [enableGhostResize]="true"
          [resizeSnapGrid]="{ left: 1, right: 1 }"
          (resizeEnd)="onResizeEnd()"
          (resizing)="onResizing($event)"
        >
          <div class="layout-with-sidebar__resize" mwlResizeHandle [resizeEdges]="{ left: true }">
            <span></span>
          </div>
        </div>
      }

      <mat-card
        class="layout-with-sidebar__sidebar-card"
        [ngClass]="{ 'mat-card-center': hasMultipleSideBar(), 'hide-card': hideSidebarCard() }"
      >
        @if (hasMultipleSideBar()) {
          <ng-template [ngTemplateOutlet]="multi()"></ng-template>
        } @else {
          <ng-template [ngTemplateOutlet]="single()"></ng-template>
        }
      </mat-card>
    </div>
  }
</div>
